module.exports = __webpack_public_path__ + "img/IMG_2456.83571c4b.jpeg";